import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { City, CityList } from 'src/app/core/models/location.model';
import { LocationService } from 'src/app/core/services/location.service';

@Component({
  selector: 'app-city-popup',
  templateUrl: './city-popup.component.html',
  styleUrls: ['./city-popup.component.scss',],
})
export class CityPopupComponent implements OnInit, OnChanges {

  @Input() openCity: boolean = false;

  showCityPopup: boolean = false;
  faTimes = faTimes;
  isLoading: boolean = false;
  cities: City[] = [];

  constructor(
    private _router: Router,
    private _locationService: LocationService,
    private _activateRoute: ActivatedRoute
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openCity'].currentValue) {
      this.loadCities();
    }
  }

  ngOnInit(): void {
    this._activateRoute.queryParams.subscribe({
      next: (params) => {
        const cityName = params['city'] || localStorage.getItem(AppConstants.CURRENT_CITY_KEY);
        if (cityName) {
          localStorage.setItem(AppConstants.CURRENT_CITY_KEY, cityName);
          return;
        }
        this.loadCities();
      },
    });
  }

  loadCities() {
    this.isLoading = true;
    this._locationService.getCities({
      isActive: true,
    }).subscribe({
      next: (data: CityList) => {
        this.cities = data.cities;
        const delay = 5000;
        setTimeout(() => {
          this.toggleCity();
        }, delay);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onCitySelected(_city: City) {
    this.toggleCity();
  }

  toggleCity() {
    this.showCityPopup = !this.showCityPopup;
  }

}
